import { render, staticRenderFns } from "./edit-club-bb.vue?vue&type=template&id=1b0c3ef0"
import script from "./edit-club-bb.vue?vue&type=script&lang=js"
export * from "./edit-club-bb.vue?vue&type=script&lang=js"
import style0 from "./edit-club-bb.vue?vue&type=style&index=0&id=1b0c3ef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports